var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class:
        _vm.$mq === "mobile" && _vm.heroSchema.mobileLayout === "below"
          ? _vm.heroSchema.mobileBgColor
          : null
    },
    [
      _vm.$mq !== "mobile"
        ? _c(
            "div",
            {
              staticClass: "hero-banner__container",
              class: _vm.heroSchema.layout,
              style: _vm.containerStyle
            },
            [
              _vm.heroSchema.backgroundVideo.length > 0
                ? _c(
                    "video",
                    {
                      staticClass: "hero-banner__background-video",
                      attrs: {
                        poster: _vm.heroSchema.image,
                        autoplay: "true",
                        muted: "true",
                        loop: "true"
                      },
                      domProps: { muted: true }
                    },
                    [
                      _c("source", {
                        attrs: { src: _vm.heroSchema.backgroundVideo }
                      })
                    ]
                  )
                : _vm._e(),
              _vm.heroSchema.heroUrl
                ? _c(
                    "a",
                    {
                      staticClass: "hero-banner",
                      class: [
                        _vm.layoutHorizontal,
                        _vm.layoutVertical(_vm.$mq),
                        _vm.textAlign
                      ],
                      style: [_vm.backgroundStyles, _vm.layoutStyle],
                      attrs: {
                        href: _vm.heroSchema.heroUrl,
                        "aria-label": _vm.heroSchema.enableTextBox
                          ? null
                          : _vm.heroSchema.ctaAria
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "hero-banner__content-container" },
                        [
                          _vm.heroSchema.overlayEnable
                            ? _c("div", {
                                staticClass: "hero-banner__content-background",
                                style: _vm.contentBackgroundStyles
                              })
                            : _vm._e(),
                          _c(
                            "div",
                            {
                              staticClass: "hero-banner__content",
                              class: _vm.contentProperties.classes,
                              style: _vm.contentProperties.style
                            },
                            [
                              _vm.heroSchema.preHeading
                                ? _c(
                                    "h4",
                                    {
                                      staticClass:
                                        "preheader hero-banner__preheading",
                                      class: _vm.heroSchema.preHeadingColor
                                    },
                                    [_vm._v(_vm._s(_vm.heroSchema.preHeading))]
                                  )
                                : _vm._e(),
                              _vm.heroSchema.heading
                                ? _c(
                                    "h2",
                                    {
                                      staticClass: "h1 hero-banner__heading",
                                      class: _vm.heroSchema.headingColor
                                    },
                                    [_vm._v(_vm._s(_vm.heroSchema.heading))]
                                  )
                                : _vm._e(),
                              _vm.heroSchema.subHeading
                                ? _c(
                                    "h3",
                                    {
                                      staticClass:
                                        "subheader hero-banner__subheading",
                                      class: _vm.heroSchema.subHeadingColor
                                    },
                                    [_vm._v(_vm._s(_vm.heroSchema.subHeading))]
                                  )
                                : _vm._e(),
                              _vm.heroSchema.copy
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "body-md hero-banner__body-copy",
                                      class: _vm.heroSchema.copyColor
                                    },
                                    [_vm._v(_vm._s(_vm.heroSchema.copy))]
                                  )
                                : _vm._e(),
                              _vm.heroSchema.enableCta && _vm.heroSchema.ctaText
                                ? _c(
                                    "div",
                                    { staticClass: "hero-banner__cta-wrapper" },
                                    [
                                      _c(
                                        "v-button",
                                        {
                                          staticClass:
                                            "hero-banner__cta button button--primary",
                                          style: {
                                            "background-color":
                                              _vm.heroSchema.ctaColor,
                                            "border-color":
                                              _vm.heroSchema.ctaBorderColor,
                                            color: _vm.heroSchema.ctaTextColor
                                          },
                                          attrs: {
                                            href: _vm.heroSchema.ctaUrl,
                                            tag: "a"
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.heroSchema.ctaText))]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          )
                        ]
                      )
                    ]
                  )
                : _c(
                    "div",
                    {
                      staticClass: "hero-banner",
                      class: [
                        _vm.layoutHorizontal,
                        _vm.layoutVertical(_vm.$mq),
                        _vm.textAlign
                      ],
                      style: [_vm.backgroundStyles, _vm.layoutStyle]
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "hero-banner__content-container" },
                        [
                          _vm.heroSchema.overlayEnable
                            ? _c("div", {
                                staticClass: "hero-banner__content-background",
                                style: _vm.contentBackgroundStyles
                              })
                            : _vm._e(),
                          _c(
                            "div",
                            {
                              staticClass: "hero-banner__content",
                              class: _vm.contentProperties.classes,
                              style: _vm.contentProperties.style
                            },
                            [
                              _vm.heroSchema.preHeading
                                ? _c(
                                    "h4",
                                    {
                                      staticClass:
                                        "preheader hero-banner__preheading",
                                      class: _vm.heroSchema.preHeadingColor
                                    },
                                    [_vm._v(_vm._s(_vm.heroSchema.preHeading))]
                                  )
                                : _vm._e(),
                              _vm.heroSchema.heading
                                ? _c(
                                    "h2",
                                    {
                                      staticClass: "h1 hero-banner__heading",
                                      class: _vm.heroSchema.headingColor
                                    },
                                    [_vm._v(_vm._s(_vm.heroSchema.heading))]
                                  )
                                : _vm._e(),
                              _vm.heroSchema.subHeading
                                ? _c(
                                    "h3",
                                    {
                                      staticClass:
                                        "subheader hero-banner__subheading",
                                      class: _vm.heroSchema.subHeadingColor
                                    },
                                    [_vm._v(_vm._s(_vm.heroSchema.subHeading))]
                                  )
                                : _vm._e(),
                              _vm.heroSchema.copy
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "body-md hero-banner__body-copy",
                                      class: _vm.heroSchema.copyColor
                                    },
                                    [_vm._v(_vm._s(_vm.heroSchema.copy))]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]
                      )
                    ]
                  )
            ]
          )
        : _c(
            "div",
            {
              ref: "main",
              staticClass: "hero-banner__container",
              style: _vm.containerStyle
            },
            [
              _c(
                "div",
                {
                  staticClass: "hero-banner",
                  class: _vm.textAlignMobile.concat(
                    [_vm.layoutVertical(_vm.$mq)],
                    [_vm.heroSchema.mobileLayout]
                  )
                },
                [
                  _vm.heroSchema.backgroundVideo.length > 0
                    ? _c(
                        "video",
                        {
                          staticClass: "hero-banner__background-video",
                          attrs: {
                            poster: _vm.heroSchema.image,
                            autoplay: "true",
                            muted: "true",
                            loop: "true",
                            playsinline: "true"
                          },
                          domProps: { muted: true }
                        },
                        [
                          _c("source", {
                            attrs: { src: _vm.heroSchema.backgroundVideo }
                          })
                        ]
                      )
                    : _vm._e(),
                  _vm.heroSchema.heroUrl
                    ? _c("a", {
                        staticClass: "hero-banner__image-mobile",
                        style: _vm.backgroundStylesMobile,
                        attrs: { href: _vm.heroSchema.heroUrl }
                      })
                    : _c("div", {
                        staticClass: "hero-banner__image-mobile",
                        style: _vm.backgroundStylesMobile
                      }),
                  _vm.contentExist
                    ? _c(
                        "div",
                        {
                          staticClass: "hero-banner__content",
                          class: [
                            ((_obj = {}),
                            (_obj[_vm.heroSchema.mobileBgColor] =
                              _vm.heroSchema.mobileLayout === "below"),
                            _obj),
                            _vm.contentProperties.classes
                          ],
                          style: _vm.contentProperties.style
                        },
                        [
                          _vm.heroSchema.preHeading
                            ? _c(
                                "h4",
                                {
                                  staticClass:
                                    "preheader hero-banner__preheading",
                                  class: _vm.heroSchema.preHeadingColorMobile
                                },
                                [_vm._v(_vm._s(_vm.heroSchema.preHeading))]
                              )
                            : _vm._e(),
                          _vm.heroSchema.heading
                            ? _c(
                                "h2",
                                {
                                  staticClass: "h1 hero-banner__heading",
                                  class: _vm.heroSchema.headingColorMobile
                                },
                                [_vm._v(_vm._s(_vm.heroSchema.heading))]
                              )
                            : _vm._e(),
                          _vm.heroSchema.subHeading
                            ? _c(
                                "h3",
                                {
                                  staticClass:
                                    "subheader hero-banner__subheading",
                                  class: _vm.heroSchema.subHeadingColorMobile
                                },
                                [_vm._v(_vm._s(_vm.heroSchema.subHeading))]
                              )
                            : _vm._e(),
                          _vm.heroSchema.copy
                            ? _c(
                                "p",
                                {
                                  staticClass: "body-md hero-banner__body-copy",
                                  class: _vm.heroSchema.copyColorMobile
                                },
                                [_vm._v(_vm._s(_vm.heroSchema.copy))]
                              )
                            : _vm._e(),
                          _vm.heroSchema.enableCta && _vm.heroSchema.ctaText
                            ? _c(
                                "div",
                                { staticClass: "hero-banner__cta-wrapper" },
                                [
                                  _c(
                                    "v-button",
                                    {
                                      staticClass:
                                        "hero-banner__cta button button--primary",
                                      style: {
                                        "background-color":
                                          _vm.heroSchema.ctaColor,
                                        "border-color":
                                          _vm.heroSchema.ctaBorderColor,
                                        color: _vm.heroSchema.ctaTextColor
                                      },
                                      attrs: {
                                        href: _vm.heroSchema.ctaUrl,
                                        tag: "a"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.heroSchema.ctaText))]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e()
                ]
              )
            ]
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }